class TestimonialsProgress {
  constructor(root) {
    this.root = root;
    this.slider = root.querySelector('.testimonials__slider');
    this.filledBar = root.querySelector('.testimonials__progress-filled');

    if (!this.slider) return;

    this.onScroll = this.onScroll.bind(this);
    this.slider.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onScroll);

    this.initDragToScroll();

    // Initial paint
    this.onScroll();
  }

  onScroll() {
    if (!this.filledBar) return;

    const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;

    // Nothing to scroll (all slides fit) - show a full bar
    if (maxScroll <= 0) {
      this.filledBar.style.width = '100%';
      return;
    }

    const scrolledFraction = this.slider.scrollLeft / maxScroll;

    // Keep a minimum sliver visible at the start, grow to 100% at the end
    const minPercent = 15;
    const percent = minPercent + scrolledFraction * (100 - minPercent);

    this.filledBar.style.width = `${percent}%`;
  }

  // Allows desktop mouse users to click-and-drag the slider,
  // since native overflow-x scroll only responds to touch/trackpad by default.
  initDragToScroll() {
    let isDown = false;
    let startX = 0;
    let startScrollLeft = 0;
    let moved = false;

    this.slider.addEventListener('mousedown', (e) => {
      isDown = true;
      moved = false;
      this.slider.classList.add('is-dragging');
      startX = e.pageX;
      startScrollLeft = this.slider.scrollLeft;
    });

    window.addEventListener('mouseup', () => {
      isDown = false;
      this.slider.classList.remove('is-dragging');
    });

    window.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const delta = e.pageX - startX;
      if (Math.abs(delta) > 5) moved = true;
      this.slider.scrollLeft = startScrollLeft - delta;
    });

    // Prevent link/card clicks from firing right after a drag
    this.slider.addEventListener(
      'click',
      (e) => {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
        }
      },
      true
    );
  }
}

document.querySelectorAll('[class*="testimonials-slider-"]').forEach((section) => {
  new TestimonialsProgress(section);
});

if (Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[class*="testimonials-slider-"]');
    if (section) new TestimonialsProgress(section);
  });
}